import _ from 'lodash';
import { Card, CardBody, CardFooter, CardItem, type CardProps } from '..';

export type EditableListProps = Omit<CardProps, 'onChange'> & {
  title?: string;
  tooltip?: string;
  items?: string[];
  readonly?: boolean;
  onChange?: (items: string[]) => void;
};

const EditableList = ({
  title,
  tooltip,
  items = [],
  readonly = false,
  onChange,
  ...rest
}: EditableListProps) => {
  return (
    <Card
      title={title}
      tooltip={tooltip}
      footer={
        !readonly && (
          <CardFooter.AddButton
            onClick={() => {
              onChange([...items, 'New category']);
            }}
          />
        )
      }
      {...rest}
    >
      <CardBody.VirtualList data={items}>
        {(item, index) => {
          if (!item) return <></>;
          return (
            <CardItem.EditTextItem
              title={item}
              onDelete={() => {
                const newItems = [...items];
                newItems.splice(index, 1);
                onChange?.(newItems);
              }}
              onChange={(value) => {
                const newItems = [...items];
                newItems.splice(index, 1, value);
                onChange?.(newItems);
              }}
              data-testid={
                rest['data-testid'] && `${rest['data-testid']}-${index}`
              }
              disable={readonly}
            />
          );
        }}
      </CardBody.VirtualList>
    </Card>
  );
};

export default EditableList;
